import { create } from 'zustand';
import type { Session, User } from '@supabase/supabase-js';
import type { Profile } from '../types';

interface UserState {
  session: Session | null;
  user: User | null;
  profile: Profile | null;
  // CLÉ i18n d'un message d'auth à afficher hors du cycle d'un écran (ex. deep link de
  // confirmation en échec), consommée par AuthScreen via son rendu d'erreur existant.
  authNoticeKey: string | null;
  // Vrai depuis le retour d'un lien de réinitialisation jusqu'à l'enregistrement du nouveau mot de
  // passe (ou l'annulation). La session existe déjà, mais l'application doit rester sur l'écran
  // « nouveau mot de passe ». Volontairement non persisté : relancer l'application n'y ramène pas.
  // C'est un VERROU D'USAGE, pas une barrière de sécurité : le lien reçu par e-mail a déjà prouvé
  // que la personne tient la boîte, et la session de récupération est valide dans tous les cas.
  // Quitter de force l'application sur cet écran laisse donc entrer avec l'ancien mot de passe.
  recoveryPending: boolean;
  setSession: (session: Session | null) => void;
  setProfile: (profile: Profile | null) => void;
  setAuthNoticeKey: (key: string | null) => void;
  setRecoveryPending: (pending: boolean) => void;
  reset: () => void;
}

const initialState = {
  session: null,
  user: null,
  profile: null,
  authNoticeKey: null,
  recoveryPending: false,
} as const;

export const useUserStore = create<UserState>((set) => ({
  ...initialState,
  setSession: (session) => set({ session, user: session?.user ?? null }),
  setProfile: (profile) => set({ profile }),
  setAuthNoticeKey: (authNoticeKey) => set({ authNoticeKey }),
  setRecoveryPending: (recoveryPending) => set({ recoveryPending }),
  reset: () => set({ ...initialState }),
}));
